// hooks
import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { BaseError } from './../../helpers/BaseError';

// models
import { TagCreate, TagModel } from './../../models/tag.model';

// constants
import API from '../../services/api';

import { queryClient } from '../../AppComposer';
import useAnalytics from '../helper/useAnalytics';

export default function useTagCreate() {
    const { track } = useAnalytics();
    return useMutation<AxiosResponse<TagModel>, BaseError, TagCreate>({
        mutationFn: API.createTag,
        onSuccess: (res) => {
            track('tag_created', {
                tagId: res?.data?.id,
            });
            queryClient.invalidateQueries({ queryKey: ['tags'] });
        },
    });
}
